
export const USER = {
  '2142022122': {
    roles: 'buy_and_manage'
  },
  '2142022159': {
    roles: 'buy_only',
  },
  '2142022161': {
    roles: 'manage_only'
  }
};

export const LOGIN_REQUIRED = [
  'efotaoffer'
]
